import React from 'react'
import CreatableSelect from 'react-select/creatable'

import PropTypes from 'prop-types'

import { RECORD_REVIEW_RECORD_TYPES } from '../constants/ActivityTemplates'

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '38px',
    borderColor: state.isFocused ? '#4c5bae' : '#ced4da',
    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(76, 91, 174, 0.25)' : null,
    fontSize: '0.875rem',
  }),
  multiValue: base => ({
    ...base,
    backgroundColor: '#e9ecef',
    borderRadius: '3px',
  }),
  multiValueLabel: base => ({
    ...base,
    color: '#495057',
    fontWeight: '500',
    fontSize: '0.8rem',
  }),
  multiValueRemove: base => ({
    ...base,
    color: '#6c757d',
    ':hover': {
      backgroundColor: '#dc3545',
      color: 'white',
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 9999,
  }),
}

const options = RECORD_REVIEW_RECORD_TYPES.map(type => ({ value: type, label: type }))

export default function RecordReviewDescriptionSelect({
  id,
  name,
  value,
  onChange,
  onBlur,
  allowEditing = true,
  placeholder = 'Select or type record types...',
}) {
  const selectedOptions = (value || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .map(t => ({ value: t, label: t }))

  const handleChange = selected => {
    const joined = (selected || [])
      .map(opt => opt.value.trim())
      .filter(Boolean)
      .join(', ')
    const truncated = joined.length > 255 ? joined.substring(0, 255) : joined
    onChange({
      target: {
        type: 'creatable-select',
        name,
        value: truncated,
      },
    })
  }

  return (
    <CreatableSelect
      id={id}
      name={name}
      isMulti
      isDisabled={!allowEditing}
      isClearable={allowEditing}
      options={options}
      value={selectedOptions}
      onChange={handleChange}
      onBlur={onBlur}
      placeholder={placeholder}
      styles={customStyles}
      formatCreateLabel={userInput => `Add "${userInput}"`}
    />
  )
}

RecordReviewDescriptionSelect.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  allowEditing: PropTypes.bool,
  placeholder: PropTypes.string,
}
